import { ROUTES, TOKEN_EXPIRED_MSG } from "../routes/config";
import { API_URL, LOGOUT_ENDPOINT } from "./endpoints";

export const fetcher = async (
    url: string,
    options?: RequestInit & {
        params?: Record<
            string,
            string | number | boolean | string[] | number[] | boolean[]
        >;
        data?: Record<string, any>;
        useDefaultContentType?: boolean;
    },
    returnError: boolean = false,
    returnAsIs: boolean = false
) => {
    try {
        const { params, data, ...fetchOptions } = options || {};
        const urlObj = new URL(API_URL + url);

        if (params) {
            Object.keys(params).forEach((key) => {
                const value = params[key];
                if (Array.isArray(value)) {
                    value.forEach((val) =>
                        urlObj.searchParams.append(key, val.toString())
                    );
                } else {
                    urlObj.searchParams.append(key, value.toString());
                }
            });
        }
        if (data) {
            fetchOptions.body = JSON.stringify(data);
        }

        const headers: HeadersInit = {
            ...(!fetchOptions?.useDefaultContentType
                ? { "Content-Type": "application/json" }
                : {}),
            ...fetchOptions?.headers,
        };

        const response = await fetch(urlObj.toString(), {
            ...fetchOptions,
            credentials: "include",
            headers,
        });
        let res;

        if (response.status === 401) {
            const publicRoutes = [
                `/${ROUTES.LOGIN.path}`,
                `/${ROUTES.RESET_PASSWORD.path}`,
            ];
            const urlSearchParams = new URLSearchParams();
            if (url !== LOGOUT_ENDPOINT) {
                urlSearchParams.append("sessionExpired", "1");
                urlSearchParams.append("redirect", window.location.pathname);
            }
            const urlSearchParamsStr = urlSearchParams.toString();
            if (!publicRoutes.includes(window.location.pathname)) {
                window.location.href = `/${ROUTES.LOGIN.path}${
                    urlSearchParamsStr ? `?${urlSearchParamsStr}` : ""
                }`;
            }
            return;
        }

        if (returnAsIs) {
            return response;
        }

        try {
            if (
                response.headers
                    .get("Content-Type")
                    ?.includes("application/json")
            ) {
                res = await response.json();
            } else {
                res = await response.text();
            }
        } catch (e) {
            console.error("Failed to parse response: ", e);
            res = { success: false, error: "Failed to parse response" };
        }

        const { success, error, msg } = res;

        if ((returnError && error) || !response.ok) {
            return {
                ...res,
                error:
                    error ||
                    msg ||
                    res.message ||
                    "An unexpected error occurred",
            };
        }

        if (error || success === false) {
            if (
                msg === TOKEN_EXPIRED_MSG &&
                window.location.pathname !== "/" + ROUTES.LOGIN.path &&
                window.location.pathname !== "/"
            ) {
                alert("Your session has expired. Please log in again.");
                window.location.href = "/login";
            }
            return null;
        }

        return res;
    } catch (e) {
        console.error("Error using fetcher: ", e);
        return null;
    }
};
